/* ============================================================
   BETH HAMIKDASH — interactions
   ============================================================ */
(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero entrance (plays once, never leaves content hidden) ---------- */
  var hero = document.getElementById('hero');
  if(hero){
    var lightUp = function(){ hero.classList.add('lit'); };
    if(reduce){ lightUp(); }
    else {
      requestAnimationFrame(lightUp);
      window.addEventListener('load', lightUp);
    }
  }

  /* ---------- Starfield ---------- */
  var canvas = document.getElementById('stars');
  if(canvas && canvas.offsetParent !== null && getComputedStyle(canvas).display !== 'none'){
    var ctx = canvas.getContext('2d'), stars = [], W, H, DPR = Math.min(window.devicePixelRatio||1, 2);
    function resize(){
      var hero = document.getElementById('hero');
      W = hero.offsetWidth; H = hero.offsetHeight;
      canvas.width = W*DPR; canvas.height = H*DPR; canvas.style.width=W+'px'; canvas.style.height=H+'px';
      ctx.setTransform(DPR,0,0,DPR,0,0);
      var n = Math.round(W*H/9000); stars = [];
      for(var i=0;i<n;i++){
        stars.push({x:Math.random()*W, y:Math.random()*H*0.92, r:Math.random()*1.3+0.2,
          a:Math.random()*0.6+0.2, tw:Math.random()*0.02+0.004, p:Math.random()*Math.PI*2,
          gold:Math.random()<0.22});
      }
    }
    function draw(){
      ctx.clearRect(0,0,W,H);
      for(var i=0;i<stars.length;i++){
        var s=stars[i]; s.p+=s.tw; var a=s.a*(0.55+0.45*Math.sin(s.p));
        ctx.beginPath(); ctx.arc(s.x,s.y,s.r,0,6.283);
        ctx.fillStyle = s.gold ? 'rgba(231,200,115,'+a+')' : 'rgba(255,252,240,'+a+')';
        ctx.fill();
      }
      if(!reduce) requestAnimationFrame(draw);
    }
    resize(); draw();
    window.addEventListener('resize', resize);
  }

  /* ---------- Parallax hero ---------- */
  var photo = document.getElementById('heroPhoto');
  var content = document.getElementById('heroContent');
  var glow = document.getElementById('heroGlow');
  if(photo && !reduce){
    var ticking=false;
    window.addEventListener('scroll', function(){
      if(ticking) return; ticking=true;
      requestAnimationFrame(function(){
        var y = window.scrollY;
        if(y < window.innerHeight*1.2){
          photo.style.transform = 'translateY('+(y*0.14)+'px)';
          content.style.transform = 'translateY('+(y*0.32)+'px)';
          content.style.opacity = Math.max(0, 1 - y/560);
        }
        ticking=false;
      });
    }, {passive:true});
  }

  /* ---------- Reveal on scroll ---------- */
  var revs = document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:0.12, rootMargin:'0px 0px -8% 0px'});
    revs.forEach(function(r){ io.observe(r); });
  } else { revs.forEach(function(r){ r.classList.add('in'); }); }

  /* ---------- 5 points: staggered cascade when section enters view ---------- */
  var pointsSec = document.getElementById('points');
  function runPointsCounters(){
    var els = pointsSec.querySelectorAll('[data-count]');
    els.forEach(function(el){
      var target = parseInt(el.getAttribute('data-count'), 10);
      var dur = 1400, start = null;
      var delay = 300; // sync roughly with the card's text reveal
      function step(ts){
        if(start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString('fr-FR');
        if(p < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString('fr-FR');
      }
      setTimeout(function(){ requestAnimationFrame(step); }, delay);
    });
  }
  if(pointsSec){
    if('IntersectionObserver' in window){
      var pio = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ pointsSec.classList.add('play'); runPointsCounters(); pio.disconnect(); } });
      }, {threshold:0.25});
      pio.observe(pointsSec);
    } else { pointsSec.classList.add('play'); runPointsCounters(); }
  }

  /* ---------- Count-up stats ---------- */
  var counted = false;
  var statsEl = document.querySelector('.stats');
  function runCount(){
    if(counted) return; counted = true;
    document.querySelectorAll('[data-count]').forEach(function(el){
      var target = +el.getAttribute('data-count'), suf = el.getAttribute('data-suffix')||'';
      var dur = 1500, t0 = null;
      function step(ts){
        if(!t0) t0 = ts; var p = Math.min((ts-t0)/dur, 1);
        var eased = 1 - Math.pow(1-p, 3);
        el.textContent = Math.round(target*eased).toLocaleString('fr-FR') + (p===1?suf:'');
        if(p<1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }
  if(statsEl){
    if('IntersectionObserver' in window){
      var io2 = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ runCount(); io2.disconnect(); } }); }, {threshold:0.4});
      io2.observe(statsEl);
    } else runCount();
  }

  /* ---------- Figurines ---------- */
  var names = ["Adam & 'Hava","Noa'h","Avraham","Yits'hak","Yaakov","Yossef","Moché","Aharon",
    "Yehochoua","Gidon","Chimchone","Dévorah","Ruth","'Hanna","Chémouel","Chaoul","David","Chelomo",
    "Eliyahou","Elicha","Yona","Yechayahou","Yirmeyahou","Ye'hezkel","Daniel","Esther","Mordekhaï",
    "Ezra","Né'hémie","'Haggaï","Zekharia"];
  var grid = document.getElementById('figGrid');
  if(grid){
    names.forEach(function(n, i){
      var initial = n.replace(/[^A-Za-zÀ-ÿ']/g,'').charAt(0).toUpperCase();
      var el = document.createElement('div');
      el.className = 'fig';
      el.innerHTML = '<span class="fig-badge">'+String(i+1).padStart(2,'0')+'</span>'+
        '<div class="fig-av"><span class="gold">'+initial+'</span></div>'+
        '<div class="name">'+n+'</div>';
      grid.appendChild(el);
    });
  }

  /* ---------- Video: instant play on hover ---------- */
  (function(){
    var card = document.getElementById('videoCard');
    var video = document.getElementById('showcaseVideo');
    var soundBtn = document.getElementById('videoSound');
    if(!card || !video) return;

    var hasSource = false;
    var srcLoaded = false;
    var srcLoading = false;
    // fetch the file into memory and use a blob URL — robust even when the
    // server doesn't support HTTP range requests (which <video> can reject).
    function ensureSrc(cb){
      if(srcLoaded){ if(cb) cb(); return; }
      var url = video.getAttribute('data-src');
      if(!url){ if(cb) cb(); return; }
      if(srcLoading){ return; }
      srcLoading = true;
      fetch(url).then(function(r){ return r.blob(); }).then(function(blob){
        video.src = URL.createObjectURL(blob);
        srcLoaded = true; srcLoading = false;
        if(cb) cb();
      }).catch(function(){
        // fallback: direct src
        video.src = url; srcLoaded = true; srcLoading = false;
        if(cb) cb();
      });
    }
    video.addEventListener('loadeddata', function(){ hasSource = true; });
    video.addEventListener('error', function(){ hasSource = false; }, true);

    var playTimer = null;
    function tryPlay(){
      if(reduce) return;
      ensureSrc(function(){
        var p = video.play();
        if(p && p.then){
          p.then(function(){ card.classList.add('playing'); })
           .catch(function(){ /* blocked → keep poster */ });
        } else {
          card.classList.add('playing');
        }
      });
    }
    function stop(){
      video.pause();
      card.classList.remove('playing');
      try { video.currentTime = 0; } catch(e){}
    }

    card.addEventListener('mouseenter', tryPlay);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focus', tryPlay);
    card.addEventListener('blur', stop);
    // touch: tap toggles
    card.addEventListener('click', function(e){
      if(e.target.closest('.video-sound')) return;
      if(card.classList.contains('playing')) stop(); else tryPlay();
    });

    if(soundBtn){
      soundBtn.addEventListener('click', function(e){
        e.stopPropagation();
        video.muted = !video.muted;
        card.classList.toggle('sound-on', !video.muted);
        soundBtn.setAttribute('aria-pressed', String(!video.muted));
        soundBtn.setAttribute('aria-label', video.muted ? 'Activer le son' : 'Couper le son');
        if(!video.muted && video.paused) tryPlay();
      });
    }
  })();

  /* ---------- Ménorah : flammes qui s'allument à l'entrée dans l'écran ---------- */
  var fxWraps = document.querySelectorAll('.menorah-wrap');
  if(fxWraps.length){
    if('IntersectionObserver' in window && !reduce){
      var fio = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting) e.target.classList.add('fx-on');
          else e.target.classList.remove('fx-on');
        });
      }, {threshold:0.35});
      fxWraps.forEach(function(w){ fio.observe(w); });
    } else {
      fxWraps.forEach(function(w){ w.classList.add('fx-on'); });
    }
  }

  document.querySelectorAll('[data-scroll], a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if(id && id.length>1 && document.querySelector(id)){
        e.preventDefault();
        document.querySelector(id).scrollIntoView({behavior:'smooth', block:'start'});
      }
    });
  });

  /* ---------- Scroll progress bar + dot nav ---------- */
  (function(){
    var bar = document.getElementById('scrollProgress');
    var nav = document.getElementById('dotNav');
    if(!bar || !nav) return;
    var dots = [].slice.call(nav.querySelectorAll('.dot'));
    var sections = dots.map(function(d){ return document.getElementById(d.getAttribute('data-target')); });
    var buyBar = document.getElementById('buyBar');
    var david = document.querySelector('.story-david');
    var parchemin = document.querySelector('.story-scroll img');
    function onScroll(){
      var st = window.pageYOffset || document.documentElement.scrollTop;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (docH > 0 ? (st / docH) * 100 : 0) + '%';
      var heroH = (document.getElementById('hero') || {}).offsetHeight || 600;
      var past = st > heroH * 0.6;
      nav.classList.toggle('show', past);
      var mid = st + window.innerHeight * 0.4, activeIdx = 0;
      for(var i=0;i<sections.length;i++){ if(sections[i] && sections[i].offsetTop <= mid) activeIdx = i; }
      dots.forEach(function(d,i){ d.classList.toggle('active', i === activeIdx); });
      // gentle parallax on the story parchment
      if(!reduce){
        var story = document.getElementById('produit');
        if(story && parchemin){
          var rel = st - story.offsetTop;
          parchemin.style.transform = 'translateY(' + (rel * -0.04) + 'px)';
        }
      }
    }
    var ticking = false;
    window.addEventListener('scroll', function(){
      if(ticking) return; ticking = true;
      requestAnimationFrame(function(){ onScroll(); ticking = false; });
    }, {passive:true});
    onScroll();
  })();

  /* ---------- Cart (Shopify native — fusionne avec le panier du site) ---------- */
  var scrim = document.getElementById('scrim');
  var drawer = document.getElementById('drawer');
  var body = document.getElementById('drawerBody');
  var foot = document.getElementById('drawerFoot');
  var countEl = document.getElementById('cartCount');
  var totalEl = document.getElementById('cartTotal');
  var toast = document.getElementById('toast');
  var toastMsg = document.getElementById('toastMsg');
  var toastT;
  var busy = false;

  // Shopify renvoie les montants en centimes.
  function fmt(cents){ return (cents/100).toLocaleString('fr-FR',{minimumFractionDigits:0,maximumFractionDigits:2}) + '€'; }

  // Met à jour les compteurs panier du thème (en-tête) pour rester synchronisé.
  function syncThemeCount(count){
    document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count], #CartCount, .cart-item-count, .header__cart-count').forEach(function(el){
      var t = el.querySelector('span') || el;
      t.textContent = count;
      el.classList.toggle('hidden', count === 0);
      el.setAttribute('data-cart-count', count);
    });
    // Beaucoup de thèmes écoutent cet évènement pour rafraîchir leur tiroir/bulle.
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
  }

  function paint(cart){
    var count = cart.item_count || 0;
    if(countEl){
      countEl.textContent = count;
      countEl.style.transform = 'scale(1.35)';
      setTimeout(function(){ countEl.style.transform=''; }, 180);
    }
    syncThemeCount(count);

    if(count === 0){
      body.innerHTML = '<div class="drawer-empty"><div class="big">Votre panier est vide</div>Ajoutez le coffret Beth Hamikdash pour commencer.</div>';
      foot.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function(it, i){
      var line = i + 1; // Shopify line index (1-based)
      var img = it.image ? '<div class="citem-img" style="background-image:url('+it.image+');background-size:cover;background-position:center"></div>' : '<div class="citem-img"></div>';
      var meta = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : (it.product_type || 'Coffret');
      var hasDiscount = it.original_line_price > it.line_price;
      var price = '<div class="price">' + (hasDiscount ? '<s>'+fmt(it.original_line_price)+'</s>' : '') + fmt(it.line_price) + '</div>';
      html +=
        '<div class="citem" data-line="'+line+'">'+
          img +
          '<div><div class="t">'+it.product_title+'</div><div class="meta">'+meta+'</div>'+
            '<div class="qty"><button data-dec aria-label="Diminuer">−</button><span>'+it.quantity+'</span><button data-inc aria-label="Augmenter">+</button></div>'+
          '</div>'+
          price +
        '</div>';
    });
    body.innerHTML = html;

    var hasGlobalDiscount = cart.original_total_price > cart.total_price;
    totalEl.innerHTML = (hasGlobalDiscount ? '<s>'+fmt(cart.original_total_price)+'</s>' : '') + fmt(cart.total_price);
    foot.style.display = 'block';

    body.querySelectorAll('.citem').forEach(function(row){
      var line = parseInt(row.getAttribute('data-line'),10);
      var cur = parseInt(row.querySelector('.qty span').textContent,10);
      row.querySelector('[data-inc]').addEventListener('click', function(){ changeLine(line, cur+1); });
      row.querySelector('[data-dec]').addEventListener('click', function(){ changeLine(line, cur-1); });
    });
  }

  function getCart(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); });
  }

  function refresh(){
    return getCart().then(paint).catch(function(){});
  }

  function changeLine(line, quantity){
    if(busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    }).then(function(r){ return r.json(); }).then(function(cart){
      busy = false; paint(cart);
    }).catch(function(){ busy = false; });
  }

  function openCart(){ scrim.classList.add('open'); drawer.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeCart(){ scrim.classList.remove('open'); drawer.classList.remove('open'); document.body.style.overflow=''; }

  function showToast(msg){
    toastMsg.textContent = msg || 'Ajouté au panier';
    toast.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(function(){ toast.classList.remove('show'); }, 2600);
  }

  function addToCart(){
    if(busy) return;
    var vid = window.BETH_VARIANT_ID;
    if(!vid){ window.location.href = '/cart'; return; } // garde-fou si l'ID n'est pas réglé
    busy = true;
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    }).then(function(r){
      if(!r.ok) return r.json().then(function(e){ throw e; });
      return r.json();
    }).then(function(){
      return getCart();
    }).then(function(cart){
      busy = false;
      paint(cart);
      showToast('Beth Hamikdash ajouté au panier');
      setTimeout(openCart, 420);
    }).catch(function(){
      busy = false;
      showToast("Impossible d'ajouter au panier");
    });
  }

  document.querySelectorAll('[data-add]').forEach(function(b){
    b.addEventListener('click', addToCart);
  });
  var cartOpenBtn = document.getElementById('cartOpen');
  if(cartOpenBtn) cartOpenBtn.addEventListener('click', function(){ refresh().then(openCart); });
  document.getElementById('cartClose').addEventListener('click', closeCart);
  scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeCart(); });
  document.getElementById('checkoutBtn').addEventListener('click', function(){
    showToast('Redirection vers le paiement sécurisé…');
    window.location.href = '/checkout';
  });
  if(countEl) countEl.style.transition = 'transform .18s ease';

  // Au chargement : reflète le panier RÉEL du site (fusion garantie).
  refresh();
})();
